<div [formGroup]= "form" class="agpr-topicWorkFlowSettings">
    <!-- Auto Tagging -->
    <ng-container>
        <agpr-checkbox
            id="agpr-topicWorkFlowSettings-useTopicToTag"
            [ngModelOptions]="{standalone: true}"
            [(ngModel)]="useTopicToTag"
            (ngModelChange)="toggleAutoTagging()"
            [binary]="true"
            label="TopicWorkflowSettings.useTopicToTag"
            [disabled]="accountAutoTaggingMaxReached && useTopicToTag === false"
        ></agpr-checkbox>
        <ng-container formGroupName="autoTag" *ngIf="useTopicToTag">
            <div class="agpr-topicWorkFlowSettings-automaticTagContainer">
                <agpr-radio
                    formControlName="isAutoTaggingSearch"
                    id="agpr-topicWorkFlowSettings-automatic"
                    [value]="true"
                    label="TopicWorkflowSettings.tagMentionsAutomatically"
                    tooltip="TopicWorkflowSettings.tagMentionsAutomatically.infoTip"
                ></agpr-radio>
                <agpr-radio
                    formControlName="isAutoTaggingSearch"
                    id="agpr-topicWorkFlowSettings-onDemand"
                    [value]="false"
                    label="TopicWorkflowSettings.tagMentionsOnDemand"
                    tooltip="TopicWorkflowSettings.tagMentionsOnDemand.infoTip"
                ></agpr-radio>
            </div>
            <div class="agpr-topicWorkFlowSettings-automaticTagPicker">
                <agpr-tags-picker
                    formControlName="tagIds"
                    [id]="'topicWorkflowSettings'"
                    [maxNumberOfTags]="maxNumberOfTags"
                    [showHeader]="false"
                    [errorMessage]="'TopicWorkflowSettings.tagLimitMessage' | localize: { limit: maxNumberOfTags }"
                ></agpr-tags-picker>
                @if (showErrors && form.errors?.['tagRequiredError']) {
                <agpr-form-message
                    [id]="'topicWorkflowSettings_rhp_autoTag_error'"
                >
                    {{ 'TopicWorkflowSettings.tagRequired' | localize }}
                </agpr-form-message>
                }
            </div>
        </ng-container>
        @if (accountAutoTaggingMaxReached) {
            <agpr-message
                [severity]="messageSeverityEnum.warning"
                class="agpr-topicWorkFlowSettings-limitReached"
            >
                {{ 'TopicWorkflowSettings.accountAutoTaggingLimitReached' | localize: { limit: maxNumberOfAutoTaggingTopics } }}
            </agpr-message>
        }
    </ng-container>
    <!-- Auto Saving -->
    @if (autoSavingProvisioned) {
    <ng-container formGroupName="autoSave">
        <agpr-checkbox
            [ngModelOptions]="{standalone: true}"
            [(ngModel)]="useAutoSave"
            (ngModelChange)="toggleAutoSaving()"   
            id="agpr-topicWorkFlowSettings-autoSaving"
            [binary]="true"
            label="TopicWorkflowSettings.autoSaving"
            infoCircleTooltip="TopicWorkflowSettings.autoSaving.tooltip"
            [disabled]="accountAutoSavingMaxReached && !isExistingAutoSave"
        ></agpr-checkbox>
       @if (useAutoSave) {
        <div 
            class="agpr-topicWorkFlowSettings-autoSaving"
            [class.agpr-topicWorkFlowSettings-autoSaving--chips]="chips.length > 0"
        >
            <label> {{'TopicWorkflowSettings.autoSaving.saveTo' | localize}} </label>
            <div class="agpr-topicWorkFlowSettings-autoSaving-inputs">
                <agpr-dropdown
                    id="agpr-topicWorkFlowSettings_autoSaving_dropdown'"
                    [options]="autoSavingOptions"
                    optionLabel="name"
                    [ngModelOptions]="{standalone: true}"
                    [(ngModel)]="selectedAutoSavingSourceOption"
                    (ngModelChange)="selectAutoSavingSource($event.value)"
                ></agpr-dropdown>
                <div class="agpr-topicWorkFlowSettings-autoSaving-input agpr-inputGroupRow agpr-inputGroupRow-input">
                    <agpr-autocomplete
                        [id]="id + '.autoComplete'"
                        labelField="name"
                        labelLookupKey="id"
                        selectedItemsHideKey="id"
                        [placeholder]="'TopicWorkflowSettings.autoSaving.' + selectedAutoSavingSourceOption.value + '.placeholder'"
                        [dropdown]="true"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="selectedAutoSavingSourceOption.value === monitoringSeriesTypes.allSavedCoverage"
                        [(ngModel)]="selectedAutoSavingSources"
                        (ngModelChange)="selectedAutoSavingSourcesChanged($event)"
                        [suggestions]="autoSavingSource$"
                        [multiSelection]="true"
                        (itemSelected)="addAutoSavingChip($event)"
                        [customOptions]="autocompleteCustomOptions"
                        ariaLabel="SourceGroup.picker.placeholder"
                    ></agpr-autocomplete>
                </div>
            </div>
            @if (chips.length > 0) {
            <ul class="agpr-topicWorkFlowSettings-autoSaving-chips">
                @for (chip of chips; track chip; let i = $index) {
                <li class="agpr-chip">
                    <span
                        [pTooltip]="chip.displayString + ' ' + autoSavingSourceTypeToStringMap[chip.type]"
                        class="agpr-chip-label"
                    >
                        {{ chip.displayString }}
                    </span>
                    <span class="agpr-chip-type"> {{ autoSavingSourceTypeToStringMap[chip.type] }} </span>
                    <button
                        [id]="id + '_autoSavingChips_' + i + '_delete'"
                        class="agpr-chip-icon agpr-i-close"
                        agprTooltip="Common.forms.chips.delete"
                        [useTooltipAsAriaLabel]="false"
                        tooltipPosition="top"
                        (click)="removeChip(chip)"
                        [attr.aria-label]="chip.displayString + ' ' + ('Common.forms.chips.delete' | localize)"
                    ></button>
                </li>
                }
            </ul>
            }
            <agpr-form-message
                *ngIf="showErrors && form.errors?.['autoSavingSourceRequiredError']"
                [id]="'topicWorkflowSettings_rhp_autoSave_source_error'"
            >
                {{ 'TopicWorkflowSettings.autoSaving.error.source' | localize }}
            </agpr-form-message>
            <div class="agpr-topicWorkFlowSettings-autoSaving-scheduler">
                <agpr-delivery-range-scheduler
                    [id]="id + '_autoSavingScheduler'"
                    [ngModelOptions]="{standalone: true}"
                    [minEndDate]="minEndDate"
                    [(ngModel)]="autoSavingTimeRange"
                    (ngModelChange)="autoSavingTimeRangeChanged($event)"
                    [showOngoingTooltip]="false"
                    timePeriodLabel="DeliveryRangeScheduler.schedule"
                ></agpr-delivery-range-scheduler>
            </div>
            @if (showErrors) {
                @if (form.errors?.['autoSavingDateRequiredError']) {
                    <agpr-form-message [id]="'topicWorkflowSettings_rhp_autoSave_date_required_error'">
                        {{ 'Alerts.input.timeRange.incomplete' | localize }}
                    </agpr-form-message>
                }
                @if (form.errors?.['autoSavingDateRangeError']) {
                    <agpr-form-message [id]="'topicWorkflowSettings_rhp_autoSave_date_range_error'">
                        {{ 'Alerts.input.timeRange.invalidDateRange' | localize }}
                    </agpr-form-message>
                }
            }
        </div>
        }
        @if (useAutoSave) {
            <agpr-message
                class="agpr-topicWorkFlowSettings-autoSaving-quotaInformation"
                [severity]="messageSeverityEnum.info"
            >
                @if (quotaInfo.savingQuota !== -1) {
                    <span>{{'TopicWorkflowSettings.message.quotaInformation1' | localize: {quota: quotaInfo.savingQuota + quotaInfo.additionalMentionQuota} }}</span>
                    <span>{{'TopicWorkflowSettings.message.quotaInformation2' | localize: {used: quotaInfo.savingQuotaUsed, quota: quotaInfo.savingQuota + quotaInfo.additionalMentionQuota} }}</span>
                }
                <agpr-button
                    [style]="buttonTypes.link"
                    label="TopicWorkflowSettings.link.usageEstimate"
                    [underline]="true"
                    (click)="openUsageEstimateDialog()"
                ></agpr-button>
            </agpr-message>
        }
        @if(accountAutoSavingMaxReached) {
            <agpr-message
                [severity]="messageSeverityEnum.warning"
                class="agpr-topicWorkFlowSettings-limitReached"
            >
                {{ 'TopicWorkflowSettings.accountAutoSavingLimitReached' | localize: { limit: maxNumberOfAutoSavingTopics } }}
            </agpr-message>
        }
    </ng-container>
    }
</div>
